import {TitleGreenSpanSecond} from "@components/title/title-green-span-second";
import {FaqAccordion} from "@components/faq/faq-accordion";
import {FC} from "react";
import {PagePropsBasicType} from "../../../../@types/types-body";

const CustomWebFaq: FC<PagePropsBasicType> = ({namespace}) => {
    return (<section className="my-12" id="section-custom-web-faq">
            <div className="container mx-auto">
                <TitleGreenSpanSecond
                    id="section-custom-web-faq-title"
                    namespace={namespace}
                    title="section_faq.title"
                    span="section_faq.span"
                    description="section_faq.description"
                />
                <FaqAccordion
                    id={1}
                    namespace={namespace}
                    key={"section-custom-web-faq-intro"}
                    object={"section_faq.faq"}
                />
            </div>
        </section>);
};

export default CustomWebFaq;
